/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/image/css/image';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/atoms/text/css/text';
import '@swisslife/patterns-base/src/atoms/button/css/button';
import '../../page-intro/css/page-intro';
import '../../quick-links/css/quick-links';
import './mood-image.scss';
import './modifier/background.scss';
import './modifier/head.scss';
import './modifier/home.scss';
import './modifier/image.scss';
import './modifier/image-16-8.scss';
import './modifier/quick-links.scss';
import './modifier/video.scss';
import './modifier/white-box.scss';
import './modifier/404.scss';
import './modifier/content-is-hidden.scss';
